import { useEffect } from 'react';
import StatusA from './StatusA';
import styles from './index.module.scss';
import EfScrollAni from '@/efscrollani';

export default function ExampleProductA() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    // 刷新页面，保持滚动条
    const saveScrollPosition = () => sessionStorage.setItem('scrollPosition', String(window.scrollY));
    const restoreScrollPosition = () => {
        const savedPosition = sessionStorage.getItem('scrollPosition');
        if (savedPosition) {
            document.documentElement.style.scrollBehavior = 'auto';
            window.scrollTo(0, parseInt(savedPosition, 10));
            setTimeout(() => {
                document.documentElement.style.scrollBehavior = '';
            }, 0);
        }
    };
    useEffect(() => {
        if (typeof window === 'undefined') return;
        restoreScrollPosition();
        window.addEventListener('scroll', saveScrollPosition);
        return () => {
            window.removeEventListener('scroll', saveScrollPosition);
        };
    }, []);

    return (
        <div className={styles.page}>
            <StatusA />
        </div>
    );
}
